import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getApiBaseUrl } from "../../config";
import { triggerSessionExpired } from "../../utils/sessionManager";

const baseQuery = fetchBaseQuery({
  baseUrl: getApiBaseUrl(),
  credentials: "include",
});

const extractErrorMessage = (error) => {
  if (!error) return "";
  const data = error.data;
  const direct = typeof data?.message === "string" ? data.message : "";
  const nested = Array.isArray(data?.errors)
    ? data.errors
        .map((item) => (typeof item?.message === "string" ? item.message : ""))
        .filter(Boolean)
        .join(" ")
    : "";
  return `${direct} ${nested}`.trim().toLowerCase();
};

const shouldTriggerSessionExpiry = (error) => {
  if (!error || error.status !== 401) return false;

  const message = extractErrorMessage(error);

  // Do not treat RBAC/authorization denials as expired sessions.
  if (message.includes("access denied") || message.includes("not authorized")) {
    return false;
  }

  // Expired/invalid/missing auth credentials should end the session.
  return (
    message.includes("invalid or expired token") ||
    message.includes("expired token") ||
    message.includes("jwt") ||
    message.includes("unauthorized")
  );
};

export const baseQueryWithAuth = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  if (shouldTriggerSessionExpiry(result.error)) {
    localStorage.removeItem("user");

    await triggerSessionExpired(api);
  }

  return result;
};

// Alias for backward compatibility
export const baseQueryWithReauth = baseQueryWithAuth;
